/**
 * Vitrine mode auth client — email/password + magic-link login, refresh, logout.
 * Mirrors backend ShowcaseAuthController (/api/v1/showcase/auth/*).
 *
 * Used ТОЛЬКО когда VITE_PWA_MODE=vitrine. Full mode уходит через /api/v1/auth/*
 * (phone+OTP), который тут не переиспользуется — pre-JWT shapes отличаются.
 */
import { http } from './http';

export interface VitrineTokens {
  accessToken: string;
  refreshToken: string;
  customerId: string;
  sessionId: string;
  expiresAt: string;
  ttlSeconds: number;
}

interface RawLoginResponse extends VitrineTokens {
  error?: string;
}

export interface OtpRequestResponse {
  requestId: string | null;
  resendInSeconds: number;
  error?: string;
}

export const vitrineAuthApi = {
  login(email: string, password: string) {
    return http
      .post<RawLoginResponse>('/v1/showcase/auth/login', { email, password })
      .then(r => r.data);
  },

  /** OTP-релогин шаг 1 — выслать код на email. Всегда 200 (anti-enum), кроме rate-limit. */
  requestOtp(email: string) {
    return http
      .post<OtpRequestResponse>('/v1/showcase/auth/otp/request', { email })
      .then(r => r.data);
  },

  /** OTP-релогин шаг 2 — проверить код → токены. */
  verifyOtp(requestId: string, code: string) {
    return http
      .post<RawLoginResponse>('/v1/showcase/auth/otp/verify', { requestId, code })
      .then(r => r.data);
  },

  loginMagic(token: string) {
    return http
      .post<RawLoginResponse>('/v1/showcase/auth/login-magic', { token })
      .then(r => r.data);
  },

  // No body — refresh token rides in the HttpOnly cookie (withCredentials).
  refresh() {
    return http
      .post<RawLoginResponse>('/v1/showcase/auth/refresh')
      .then(r => r.data);
  },

  // The Home Screen app's first launch: exchange the COPIED refresh cookie for a session of its own, leaving the
  // browser's original untouched (rotating the shared chain got the client signed out later — reuse detection).
  adopt() {
    return http
      .post<RawLoginResponse>('/v1/showcase/auth/adopt')
      .then(r => r.data);
  },
};
